import { useMutation } from "@tanstack/react-query";
import { createAccessRequest } from "controller/api";
import type { ApiErrorType } from "shared";
import { sentryLogger } from "utilz";

/**
 * Requests access to a gated feature. Safe to call repeatedly — the endpoint
 * upserts on (tenant, user, feature).
 */
export const useCreateAccessRequest = () => {
  return useMutation({
    mutationFn: (featureName: string) => createAccessRequest(featureName),
    onError: (error: ApiErrorType, variables) => {
      sentryLogger({
        error: error,
        data: { featureName: variables },
        workflow: "integration",
        level: "error",
        functionName: "useCreateAccessRequest",
      });
    },
  });
};
